module.exports = __webpack_public_path__ + "static/media/food.1356509a.svg";